"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @uifabric/utilities@6.45.1
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.
var set_version_1 = require("@uifabric/set-version");
set_version_1.setVersion('@uifabric/utilities', '6.45.1');
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib-commonjs/version.js
// module id = 568
// module chunks = 0